import $ from "jquery";
import uly from "ulysses/base";
import ko from "knockout";
import "jquery-ui/ui/widgets/sortable";

"use strict";
var layouts = {
    "2+1":function(settings) {
        return [ [
            { "widgets":settings.left, "layoutclass":"col-xs-12 col-sm-8 col-md-8 col-lg-5 clearfix column" },
            { "widgets":settings.right, "layoutclass":"layout-small col-xs-12 col-sm-4 col-md-4 col-lg-2 clearfix column pull-right" },
            { "widgets":settings.middle, "layoutclass":"col-xs-12 col-sm-8 col-md-8 col-lg-5 clearfix column"}
        ] ];
    },
    "2":function(settings) {
        return [ [
            { "widgets":settings.left, "layoutclass":"col-xs-12 col-sm-12 col-md-6 clearfix column" },
            { "widgets":settings.middle, "layoutclass":"col-xs-12 col-sm-12 col-md-6 clearfix column" },
            { "widgets":settings.right, "layoutclass":"col-xs-12  col-sm-12 col-md-6 clearfix column"}
        ] ];
    },
    "3":function(settings) {
        return [ [
            { "widgets":settings.left, "layoutclass":"col-xs-12  col-sm-12 col-md-4 clearfix column" },
            { "widgets":settings.middle, "layoutclass":"col-xs-12  col-sm-12 col-md-4 clearfix column" },
            { "widgets":settings.right, "layoutclass":"col-xs-12  col-sm-12 col-md-4 clearfix column"}
        ] ];
    },
    "1,1,1":function(settings) {
        return [
            [
                { "widgets":settings.left, "layoutclass":"col-xs-12 clearfix column" }
            ], [
                { "widgets":settings.middle, "layoutclass":"col-xs-12 clearfix column" }
            ], [
                { "widgets":settings.right, "layoutclass":"col-xs-12 clearfix column" }
            ] ];
    },
    "1,1+1":function(settings) {
        return [
            [
                { "widgets":settings.left, "layoutclass":"col-xs-12 col-sm-7 clearfix column" },
                { "widgets":settings.right, "layoutclass":"layout-small col-xs-12 col-sm-5 pull-right clearfix column" },
                { "widgets":settings.middle, "layoutclass":"col-xs-12 col-sm-9 clearfix column" }
            ]
        ];
    },
    "6,3,3": function(settings) {
        return [
            [
                { "widgets":settings.left, "layoutclass":"col-xs-12 col-sm-4 col-md-6 clearfix column" },
                { "widgets":settings.right, "layoutclass":"layout-small col-xs-12 col-sm-4 col-md-3 pull-right clearfix column" },
                { "widgets":settings.middle, "layoutclass":"col-xs-12 col-sm-4 col-md-3 clearfix column" }
            ]
        ];
    },
    "3,6,3": function(settings) {
        return [
            [
                { "widgets":settings.left, "layoutclass":"col-xs-12 col-sm-4 col-md-3 clearfix column" },
                { "widgets":settings.right, "layoutclass":"layout-small col-xs-12 col-sm-4 col-md-3 pull-right clearfix column" },
                { "widgets":settings.middle, "layoutclass":"col-xs-12 col-sm-4 col-md-6 clearfix column" }
            ]
        ];
    },
    "3,3,6": function(settings) {
        return [
            [
                { "widgets":settings.left, "layoutclass":"col-xs-12 col-sm-4 col-md-3 clearfix column" },
                { "widgets":settings.right, "layoutclass":"layout-small col-xs-12 col-sm-4 col-md-6 pull-right clearfix column" },
                { "widgets":settings.middle, "layoutclass":"col-xs-12 col-sm-4 col-md-3 clearfix column" }
            ]
        ];
    },
    "9,3+12": function(settings) {
        return [ [
                { "widgets":settings.left, "layoutclass":"col-xs-12 col-sm-7 col-md-9 clearfix column" },
                { "widgets":settings.right, "layoutclass":"layout-small col-xs-12 col-sm-5 col-md-3 pull-right clearfix column" },
                { "widgets":settings.middle, "layoutclass":"col-xs-12 clearfix column" }
        ] ];
    },
    "12+6,6": function(settings) {
        return [ [
            { "widgets":settings.left, "layoutclass":"col-xs-12 clearfix column" },
            { "widgets":settings.right, "layoutclass":"col-xs-12 col-sm-6 clearfix column" },
            { "widgets":settings.middle, "layoutclass":"layout-small col-xs-12 col-sm-6 pull-right clearfix column" },
        ] ];
    }
};

class ColumnContainer {
    constructor(settingsObservable) {
        this.widgets = ko.pureComputed(() => {
            let vals = settingsObservable();
            if (!vals) {
                return [];
            }
            return vals.map((value, idx) => {
                let widget = uly.widgets.get_registered()[value.type];
                if (widget) {

                } else {
                    return null;
                }

            }).filter((v) => v != null)
        });
    }
}
var _build_row_observable = function _build_row_observable(settings_obs) {
    return ko.pureComputed(function() {
        var settings = ko.unwrap(settings_obs);
        var layout = ko.unwrap(settings.layout) || "2+1";
        return (layouts[layout] || layouts["2+1"])(settings);
    });
};

ko.bindingHandlers.settingslayout = {
    init:function settingslayout_init(elt,va,bindings,model,context) {
        var settings = ko.unwrap(va());
        var layout = ko.unwrap(settings.layout);
        var settings_model = {
            "rows":_build_row_observable(va())
        };
        var child_context = context.createChildContext(settings_model);
        $(elt).data("settings_layout", child_context);
        ko.applyBindingsToDescendants(child_context, elt);
        return { "controlsDescendantBindings":true };
    }
};

ko.bindingHandlers.sortable = {
    init: function(elt, va, bindings, model, context){
        ko.applyBindingsToDescendants(context, elt);
        $(elt).removeClass("loader");
        return { controlsDescendantBindings: true };
    }
};

ko.bindingHandlers.columncontainer = {
    init: function(elt, va, bindings, model, context){
        var column = ko.unwrap(va());
        if (!uly.utils.is_mobile() && uly.page.userprofile.has_permission("editpage")) {
            $(elt).sortable({
                placeholder: "sort-highlight",
                tolerance: "pointer",
                connectWith: ".column",
                handle: ".box-header, .pre-drag-handle+div .small-box",
                forcePlaceholderSize: true,
                distance: 5,
                receive:function(e, ui){
                    var cloned = ko.toJS(ko.dataFor(ui.item[0]));
                    if ("compact" in cloned)
                        delete cloned.compact;
                    va().splice($.data(ui.item[0], "tmp-index"), 0, cloned);
                    ui.item.remove();
                },
                remove:function(e, ui){
                    $.data(ui.item[0], "tmp-index", ui.item.index());
                    if(!ui.item.parent().hasClass("sidebar-menu")){
                        va().splice($.data(ui.item[0], "old-index"),1);
                    }else{
                        $.data(elt, "removing", true);
                        return false;
                    }
                },
                start:function(e, ui){
                    $.data(ui.item[0], "old-index", ui.item.index());
                },
                stop:function(e, ui){
                    var old_index = $.data(ui.item[0], "old-index");
                    var removing = $.data(elt, "removing");
                    var data = ko.dataFor(ui.item[0]);
                    if (old_index && !removing && ui.item.index() > -1 && ui.sender === null){
                        va().splice(old_index, 1);
                        va().splice(ui.item.index(), 0, data);
                        ui.item.remove();
                    }
                    $.data(elt, "removing", false);
                    uly.publish("page.savesettings");
                }
            });
        }

        var new_context = context.extend({
            "widget_list":va(),
            "fadein":function(elt){ if (elt.nodeType === 1) { $(elt).hide().slideDown(500); }},
            "fadeout": function(elt) { if (elt.nodeType === 1) { $(elt).slideUp(500); } },
            "compact":false
        });
        ko.applyBindingsToDescendants(new_context, elt);

//            $.equery();

        return { controlsDescendantBindings: true };
    }
};

ko.bindingHandlers.sidebarcolumncontainer = {
    init: function(elt, va, bindings, model, context){
        var column = ko.unwrap(va());
        $(elt).sortable({
            placeholder: "sort-highlight",
            tolerance: "pointer",
            connectWith: ".column",
            forcePlaceholderSize: true,
            receive:function(e, ui){
                var cloned = ko.toJS(ko.dataFor(ui.item[0]));
                cloned.compact = true;
                va().splice($.data(ui.item[0], "tmp-index"), 0, cloned);
                return false;
            },
            remove:function(e, ui){
                $.data(ui.item[0], "tmp-index", ui.item.index());
                $.data(elt, "removing", true);
                return false;
            },
            start:function(e, ui){
                $.data(ui.item[0], "old-index", ui.item.index());
            },
            update:function(e, ui){
                var old_index = $.data(ui.item[0], "old-index");

                var removing = $.data(elt, "removing");
                if (old_index && !removing && ui.item.index() > -1 && ui.sender === null){
                    va().splice(old_index, 1);
                    va().splice(ui.item.index(), 0, ko.dataFor(ui.item[0]));
                    ui.item.remove();
                }
                $.data(elt, "removing", false);
                uly.publish("sidebar.savesettings");
            }
        }).disableSelection();
        var new_context = context.extend({ "widget_list":va(), "compact":true });
        ko.applyBindingsToDescendants(new_context, elt);
        $(elt).removeClass("loader");
        return { controlsDescendantBindings: true };
    }
};
